import $image_url from 'js/utils/image_url';
import { defaultProps, propTypes } from './mapbox_defaults';

export const mapboxStaticUrl = (props) => {
  const { longitude, latitude, zoom, bearing, pitch, width, height, mapStyle } =
    { ...defaultProps, ...props };

  if (!longitude || !latitude)
    return $image_url('readers/unknown_location@2x.png');

  return (
    'https://api.mapbox.com' +
    `/styles/v1/${mapStyle}/static` +
    `/${longitude},${latitude},${zoom}` +
    `,${bearing},${pitch}` +
    `/${width}x${height}@2x` +
    `?access_token=pk.eyJ1IjoiYWNhZGVtaWFlZHUiLCJhIjoiY2l1NGpzZDhlMGhmNzJvbGs0bTI3ZDk5cSJ9.k130x1flnGwe800cEzp4Qw&logo=false&attribution=false`
  );
};

export const MapboxStatic = ({
  longitude,
  latitude,
  zoom,
  bearing,
  pitch,
  width,
  height,
  mapStyle,
  ...props
}) => {
  const imgUrl = mapboxStaticUrl({
    longitude,
    latitude,
    zoom,
    bearing,
    pitch,
    width,
    height,
    mapStyle,
  });

  return <img src={imgUrl} alt="map" {...props} />;
};

MapboxStatic.defaultProps = { ...defaultProps };
MapboxStatic.propTypes = { ...propTypes };
